// extracted by mini-css-extract-plugin
export default {"logo":"LoginLayout_logo__q9VO5","slider":"LoginLayout_slider__i-aE2"};